// @flow

import React from "react";

import { curry, isEmpty, isNil } from "ramda";

import {
  SelecaoAjusteDePreco,
  SelecaoDeflacao,
  SelecaoNormalizacao,
  SelecaoCorrecaoMonetaria,
} from "../configuracoes";
import {
  type ErrosSelecao,
  type MedidaSelecionada,
  ID_TIPO_AJUSTE_PRECO_PADRAO,
  ID_OPCAO_DEFLATOR_NENHUM,
  ID_OPCAO_CORRETOR_MONETARIO_NENHUM,
} from "../../../model";

import {
  type State,
  i18n,
  getAjustesPrecoSelecionados,
  getEdicaoMedida,
  getExibirConfiguracoesAvancadas,
  analiseValorDaMedida,
} from "../../../state";

export const criaFuncaoValidacaoSeriesComAjusteEDeflatorCorrecao = (
  state: State
) => (): ?ErrosSelecao => {
  const erros: ErrosSelecao = {};
  const { translate } = i18n(state);

  if (isEmpty(getAjustesPrecoSelecionados(state)))
    erros.ajustesPrecoNaoSelecionados = translate("erro.selecioneAjuste");

  return erros;
};

export const processarSeriesComAjusteEDeflatorCorrecao = curry(
  (
    processarUltimaNegociacao,
    state: State,
    medidas: Array<MedidaSelecionada>
  ): Array<MedidaSelecionada> => {
    const ajustesPreco = getAjustesPrecoSelecionados(state) || [];
    const edicaoMedida = getEdicaoMedida(state);
    const exibirConfiguracoesAvancadas = getExibirConfiguracoesAvancadas(state);

    return medidas.flatMap(medida =>
      ajustesPreco.map(ajuste => {
        const ultimaNegociacao =
          processarUltimaNegociacao && edicaoMedida.ultimaNegociacaoMes;

        if (exibirConfiguracoesAvancadas) {
          const configCorrecao =
            !isNil(edicaoMedida.corretorMonetario) &&
            edicaoMedida.corretorMonetario !==
              ID_OPCAO_CORRETOR_MONETARIO_NENHUM
              ? {
                  correcaoMonetaria: edicaoMedida.corretorMonetario,
                }
              : {};
          const configDeflator =
            !isNil(edicaoMedida.deflator) &&
            edicaoMedida.deflator !== ID_OPCAO_DEFLATOR_NENHUM
              ? {
                  deflator: edicaoMedida.deflator,
                }
              : {};
          const configValorDataBase =
            !isNil(edicaoMedida.valorBaseDeflator) &&
            !isNil(edicaoMedida.dataBaseDeflator)
              ? {
                  valorBaseDeflator: edicaoMedida.valorBaseDeflator,
                  valorBaseDeflatorOutro: edicaoMedida.valorBaseDeflatorOutro,
                  dataBaseDeflator: edicaoMedida.dataBaseDeflator,
                  dataBaseDeflatorDataEspecifica:
                    edicaoMedida.dataBaseDeflatorDataEspecifica,
                }
              : {};

          return {
            ...medida,
            tipoAjuste: ajuste,
            ...configCorrecao,
            ...configDeflator,
            ...configValorDataBase,
            ultimaNegociacao,
            ...analiseValorDaMedida(medida, state),
          };
        } else {
          return {
            ...medida,
            tipoAjuste: ID_TIPO_AJUSTE_PRECO_PADRAO,
            ultimaNegociacao,
            ...analiseValorDaMedida(medida, state),
          };
        }
      })
    );
  }
);

const SeriesComAjusteEDeflatorCorrecao = () => {
  return (
    <>
      <SelecaoAjusteDePreco />
      <div className="ConfiguracaoMedida__vertical-divider" />
      <div className="ConfiguracaoMedida__box">
        <div className="ConfiguracaoMedida--row">
          <SelecaoDeflacao exibirNormalizacao={false} />
          <SelecaoCorrecaoMonetaria />
        </div>
        <div className="ConfiguracaoMedida--row">
          <SelecaoNormalizacao
            forcarExibirNormalizacao={true}
            exibirOpcaoNenhum={true}
            utilizarEspacoTotal={true}
          />
        </div>
      </div>
    </>
  );
};

export default SeriesComAjusteEDeflatorCorrecao;
